import $ from "jquery";
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel';

class Carousel {

	Init = () => {
		$('[data-carousel]').each(function() {
			let oc, items, loops = true, mouseDrags = true, touchDrags = true;
			oc = $(this);
			items = oc.attr('data-items');
			if(oc.attr('data-loop-false')){
				loops = false;
				mouseDrags = false;
				touchDrags = false;
			}
			oc.addClass('owl-carousel').owlCarousel({
				items: items,
				slideBy: items,
				dots: true,
				nav: true,
				stagePadding: 0,
				navText: ['', ''],
				mouseDrag: mouseDrags,
				touchDrag: touchDrags,
				loop: loops,
				lazyLoad: true,
				smartSpeed: 750,
				onChanged: function(event) {
					let it = oc.find('.owl-item:eq(' + event.item.index + ') .item');
					oc.siblings('.photo-title').find('span').html(it.attr('data-title') || '&nbsp;');
				},
				onLoadedLazy: function (e) {
					$(e.target).find('.active').addClass('loaded');
				}
			});
		});
		$('.inline-gallery-out__left').bind("click", function(e){
			e.preventDefault();
			$('.inline-gallery .owl-prev').click();
		});
		$('.inline-gallery-out__right').bind("click", function(e){
			e.preventDefault();
			$('.inline-gallery .owl-next').click();
		});

	};

}

export default new Carousel;